module.exports = __webpack_public_path__ + "/login_ui/img/by-245578c1316313779fd91e08c7a61f54.svg";